module.exports = __webpack_public_path__ + "images/emoji/volcano.aff86ce7ab799a5424a2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/volcano.png
// module id = yVNm
// module chunks = 13